import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <>
      <Section className="text-xl md:text-2xl leading-relaxed text-[#3D2B1F]/90" data-id="element-104">
        <div className="space-y-8" data-id="element-105">
          <p className="drop-cap" data-id="element-106">
            No es solo tristeza. Es ese vacío que te aprieta por dentro como si
            el silencio tuviera peso. Y lo peor es esto: no quieres molestar a
            nadie. No quieres dar lástima. No quieres contar tu historia otra
            vez. Solo quieres saber qué hacer…
            <strong className="text-[#B8845C] font-semibold" data-id="element-107">
              {' '}
              cuando te pega.
            </strong>
          </p>
        </div>
      </Section>

      <Section className="bg-white/50 rounded-3xl my-12 border border-[#D4A89A]/20 shadow-sm" data-id="element-108">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] mb-8 text-center" data-id="element-109">
          Si esto te suena, no estás sola:
        </h2>

        <div className="space-y-6" data-id="element-110">
          {['“En el día medio la llevo… pero en la tarde me caigo.”', '“Prendo la tele solo para que haya ruido.”', '“Me da vergüenza llamar. Siento que molesto.”', '“A veces ni ganas de comer me dan.”', '“Me siento sola incluso cuando hay gente.”'].map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-111">
              <span className="text-[#B8845C] text-4xl leading-none font-serif opacity-50" data-id="element-112">
                "
              </span>
              <p className="text-lg md:text-xl text-[#3D2B1F] italic" data-id="element-113">
                {quote.replace(/“|”/g, '')}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-12 p-8 bg-[#FAF6F0] rounded-xl border-l-4 border-[#B8845C]" data-id="element-114">
          <p className="text-lg md:text-xl leading-relaxed" data-id="element-115">
            No estás “mal”. No estás “atrasada”. Y no te falta carácter. Te
            falta algo más simple (y más importante):{' '}
            <strong className="text-[#B8845C]" data-id="element-116">Estructura.</strong>
            <br data-id="element-117" />
            <br data-id="element-118" />
            Porque el duelo y la soledad no solo te duelen… también te
            desordenan el día. Y cuando el día se queda sin costuras, el dolor
            se mete por todas partes.
          </p>
        </div>
      </Section>

      <Section data-id="element-119">
        <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] mb-8" data-id="element-120">
          Lo que nadie te dice (pero tú ya viviste)
        </h2>
        <p className="text-xl mb-8" data-id="element-121">
          La mayoría de consejos para el duelo suenan bien… hasta que llega la
          hora difícil.
        </p>

        <div className="grid gap-8 md:grid-cols-3 mb-12" data-id="element-122">
          {[{
          title: '“Sal y socializa”',
          desc: '¿Con qué energía? ¿Con qué ánimo? ¿Y si no quieres que te vean rota?'
        }, {
          title: '“Mantente ocupada”',
          desc: 'Te ocupa dos horas… y en la noche te deja sola con todo.'
        }, {
          title: '“Sé fuerte”',
          desc: 'Te vuelve dura por fuera… y agotada por dentro.'
        }].map((item, i) => <motion.div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-[#D4A89A]/10" whileHover={{
          y: -5
        }} transition={{
          duration: 0.3
        }} data-id="element-123">
              <h3 className="text-xl font-bold text-[#B8845C] mb-3" data-id="element-124">
                {item.title}
              </h3>
              <p className="text-[#3D2B1F]/80" data-id="element-125">{item.desc}</p>
            </motion.div>)}
        </div>

        <p className="text-xl md:text-2xl font-serif text-center max-w-3xl mx-auto leading-relaxed" data-id="element-126">
          La verdad es que muchas mujeres no necesitan más consejos. Necesitan
          un <span className="bg-[#D4A89A]/20 px-2 rounded" data-id="element-127">plan pequeño</span>,
          casi “tonto” de lo simple… pero hecho para el momento real en que te
          pega.
        </p>
      </Section>
    </>;
}